<template>
    <div class="image-block col-md-4 col-sm-6 col-xs-12 mb-5">
        <div class="">
            <h5 class="mt-5" v-html="label"></h5>
            <img :src="imageSrc">

            <a href="#" class="btn btn-theme-colored2 mt-5 mb-5" @click.prevent="openFileUploadField" v-if="!uploaded">
                <i class="fa fa-upload"></i>
                {{ $t('upload_image') }}
            </a>

            <form enctype="multipart/form-data" novalidate method="POST" :action="action" v-show="uploaded" ref="uploadForm">
                <input type="hidden" name="_token" :value="csrfToken">
                <input type="hidden" name="destination" :value="destination" >
                <input style="display:none" type="file" name="photo" accept="image/*" ref="uploadField" @change="displayUploadedImage">

                <span class="upload-buttons btn-group mt-5">
                    <button type="submit" class="btn btn-theme-colored2 col-md-6" @click.prevent="submit">
                        <i class="fa fa-upload"></i>
                        {{ $t('save') }}
                    </button>
                    <button class="btn btn-theme-colored col-md-6" @click.prevent="cancelUpload">
                        <i class="fa fa-undo"></i>
                        {{ $t('cancel') }}
                    </button>
                </span>
            </form>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            src: String,
            label: String,
            action: String,
        },
        data: function () {
            return {
                newImageSrc: null,
            }
        },
        computed: {
            destination() {
                return this.src.replace('/images', '');
            },
            imageSrc() {
                return this.newImageSrc != null
                    ? this.newImageSrc
                    : this.src;
            },
            csrfToken() {
                return document.querySelector('meta[name="csrf-token"]').content;
            },
            uploaded() {
                return this.newImageSrc != null;
            }
        },
        methods: {
            openFileUploadField: function () {
                this.$refs.uploadField.click();
            },
            submit: function () {
                this.$refs.uploadForm.submit();
            },
            displayUploadedImage: function (event) {
                const file = event.target.files[0];

                var reader = new FileReader();

                reader.onload = (e) => {
                    this.newImageSrc = e.target.result;
                }

                reader.readAsDataURL(file);
            },
            cancelUpload: function () {
                this.newImageSrc = null;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SiteImageLoader.vue